import React from 'react';
import PropTypes from "prop-types";

import './index.css'

const defaultStyle = {
  fontSize: '14px',
  fontWeight: 300,
  paddingTop: '8px',
  paddingLeft: '18px',
  paddingRight: '18px',
  paddingBottom: '8px',
  height: '44px',
  marginBottom: 0,
  width: '100%',
};

export default class Input extends React.Component {
  render() {
    const {
      style,
    } = this.props;

    const mergedStyle = Object.assign(defaultStyle, style);

    return (
      <input
        ref={ref => this.input = ref}
        {...this.props}
        className={'input'}
        style={mergedStyle}
      />
    )
  }
};

Input.defaultProps = {
  style: {}
};

Input.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string
};